/** Customer names are always stored and shown in ALL CAPS across manage. */
export function formatCustomerNameInput(value) {
  return String(value ?? "").toUpperCase();
}

export function normalizeCustomerName(value) {
  return formatCustomerNameInput(value).trim();
}

export function displayCustomerName(value) {
  const normalized = normalizeCustomerName(value);
  return normalized || "—";
}
